<template>
  <div class="content o checkout">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
      >
        <nav aria-label="breadcrumb" role="navigation" class="m-0 px-4">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'Search' }"> Home</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
             Checkout
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <h1 class="section_header px-4">Checkout</h1>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <div class="checkout-wrap">
          <div class="checkout-card">
            <span class="checkout-title">Checkout</span>
            <div class="md-layout" >
              <div class="md-layout-item md-size-100 mt-4 text-center">
                <div class="section-title text-center">
                  Checkout Successful<br/>
                  Thank you for your order!
                </div>
                <div class="section-sub-title text-center">

                </div>
                <router-link :to="{ name: 'Search' }">
                  <md-button
                    type="button"
                    id="custom-button" @click="createToken"
                    class="md-raised md-info md-round mt-4"
                  >Return to Dashboard</md-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';

export default {
  components: {
  },
  data() {
    return {
      loading: true,
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      billingFirstname: null,
      billingLastname: null,
      billingemailAddress: null,
      billingAddressCity: null,
      billingAddressCountry: null,
      billingAddressLine1: null,
      billingAddressLine2: null,
      billingAddressPostalCode: null,
      billingAddressState: null,
      billingPhone: null,
    };
  },
  validations: {
    billingFirstname: {
      required,
    },
    billingLastname: {
      required,
    },
    billingAddressCity: {
      required,
    },
    billingAddressCountry: {
      required,
    },
    billingAddressLine1: {
      required,
    },
    // billingAddressLine2: {
    //   required,
    // },
    billingAddressPostalCode: {
      required,
    },
    billingAddressState: {
      required,
    },
    billingPhone: {
      required
    },
    billingemailAddress: {
      required,
      email,
    },
  },
  computed: {
    ...mapState({
      cart: (state) => {
        let cart = state.cart.cart;
        cart.forEach(item => {
          item.quantity = 1;
        });

        return cart;
      },
      stripeElements () {
        return this.$stripe.elements();
      },
      user: (state) => state.user,
      subTotal: (state) => state.cart.subTotal,
      total: (state) => state.cart.total,
    }),
    shoppingTotal() {
      return this.shoppingCartTable.reduce((accumulator, current) => {
        return accumulator + current.amount;
      }, 0);
    },
  },
  methods: {
    getAlignClasses: ({ id }) => ({
      'text-right': id,
    }),
    computeAmount(item) {
      item.amount = item.qty * item.price;
    },
    async getCart() {
      await this.$store.dispatch('cart/list').then((res) => {
        this.loading = false;
      });
    },
    async createToken () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const { token, error } = await this.$stripe.createToken(this.cardNumber);
      if (error) {
        // handle error here
        document.getElementById('card-error').innerHTML = error.message;
        return;
      }
      // handle the token
      // send it to your server
      let params = {
        billingFirstname: this.billingFirstname,
        billingLastname: this.billingLastname,
        billingemailAddress: this.billingemailAddress,
        billingAddressCity: this.billingAddressCity,
        billingAddressCountry: this.billingAddressCountry,
        billingAddressLine1: this.billingAddressLine1,
        billingAddressLine2: this.billingAddressLine2,
        billingAddressPostalCode: this.billingAddressPostalCode,
        billingAddressState: this.billingAddressState,
        billingPhone: this.billingPhone,
        total: this.total,
        stripeToken: token,
      }

      await this.$store.dispatch('checkout/stripeCheckout', params).then((res) => {
        this.loading = false;

        if (res.success) {
          rewardful('convert', { email: this.billingemailAddress }); // TODO: new!
          this.$router.push({
            name: 'CheckoutSuccess'
          });
        }
      });
    },
  },
  async created() {
    await this.getCart();
  },
  async mounted() {
    // Style Object documentation here: https://stripe.com/docs/js/appendix/style
    const style = {
      base: {
        color: '#3c4858',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
          color: '#aab7c4',
        },
        border: '1px solid #d9d9d9',
        padding: '0 15px',
        lineHeight: '34px'
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };

    setTimeout(async function () {
      this.cardNumber = await this.stripeElements.create('cardNumber', { style });
      this.cardNumber.mount('#card-number');
      this.cardExpiry = await this.stripeElements.create('cardExpiry', { style });
      this.cardExpiry.mount('#card-expiry');
      this.cardCvc = await this.stripeElements.create('cardCvc', { style });
      this.cardCvc.mount('#card-cvc');

      this.billingFirstname = this.user.user.firstNameBilling;
      this.billingLastname = this.user.user.lastNameBilling;
      this.billingemailAddress = this.user.user.emailBilling;
      this.emailAddress = this.user.user.email;
    }.bind(this), 2000)
  },
  beforeDestroy () {
    if (this.cardNumber) {
      this.cardNumber.destroy();
    }
    if (this.cardExpiry) {
      this.cardExpiry.destroy();
    }
    if (this.cardCvc) {
      this.cardCvc.destroy();
    }
  },
};
</script>
<style lang="scss">
</style>
